<div class="drug-wizard-container">
  <div class="wizard-header flex justify-between items-center">
    <h3>Add New Drug</h3>
    <button mat-icon-button (click)="cancel()" class="cross-wizard cursor-pointer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-horizontal-stepper #stepper linear labelPosition="bottom">
    <!-- Step 1: Images & Basic Info -->
    <mat-step [stepControl]="basicInfoForm" label="Images & Basic Info" state="image">
      <ng-template matStepLabel>Images & Basic Info</ng-template>
      <form [formGroup]="basicInfoForm" class="step-form">
        <div class="step-content grid grid-cols-2 gap-4">
          <!-- Left column: Images -->
          <div class="images-container">
            <h4>Drug Images</h4>
            <p>Upload images of the drug from different angles. Images must be JPG, JPEG, PNG, or GIF format.</p>

            <div class="grid grid-cols-2 gap-4">
              <!-- Front Image -->
              <div class="image-upload-container">
                <mat-card appearance="outlined">
                  <mat-card-title class="flex justify-center content-stretch items-stretch">Front Image
                  </mat-card-title>
                  <mat-card-content class="flex justify-center content-stretch items-stretch">
                    <div class="file-upload">
                      <div class="selected-file">
                        <img [src]="getBase64ImageSrc(frontImage)??defaultImage" alt="drug image">
                      </div>
                      <div *ngIf="frontImage!= null" style="text-align: center;">
                        <button class="btn btn-active" (click)="selectedFrontFileRemove()">
                          <mat-icon>clear</mat-icon>Remove</button>
                      </div>
                      <div class="choose_file_syn" *ngIf="frontImage == null">
                        <label for="choose_file_syn">
                          <input type="file" id="choose_file_syn" accept="image/png, image/gif, image/jpeg"
                            (change)="onFileSelected($event, 1)">
                          <span>Click to Upload</span>
                        </label>

                      </div>

                    </div>

                  </mat-card-content>

                </mat-card>
              </div>

              <!-- Back Image -->
              <div class="image-upload-container">
                <mat-card appearance="outlined">
                  <mat-card-title class="flex justify-center content-stretch items-stretch">Back Image </mat-card-title>
                  <mat-card-content class="flex justify-center content-stretch items-stretch">
                    <div class="file-upload">
                      <div class="selected-file">
                        <img [src]="getBase64ImageSrc(backImage)??defaultImage" alt="drug image">
                      </div>
                      <div *ngIf="backImage!= null" style="text-align: center;">
                        <button class="btn btn-active" (click)="selectedBackFileRemove()">
                          <mat-icon>clear</mat-icon>Remove</button>
                      </div>
                      <div class="choose_file_back" *ngIf="backImage == null">
                        <label for="choose_file_back">
                          <input type="file" id="choose_file_back" accept="image/png, image/gif, image/jpeg"
                            (change)="onFileSelected($event, 2)">
                          <span>Click to Upload</span>
                        </label>

                      </div>

                    </div>

                  </mat-card-content>

                </mat-card>
              </div>

              <!-- Side Image -->
              <div class="image-upload-container">
                <mat-card appearance="outlined">
                  <mat-card-title class="flex justify-center content-stretch items-stretch">Side Image </mat-card-title>
                  <mat-card-content class="flex justify-center content-stretch items-stretch">
                    <div class="file-upload">
                      <div class="selected-file">
                        <img [src]="getBase64ImageSrc(sideImage)??defaultImage" alt="drug image">
                      </div>
                      <div *ngIf="sideImage!= null" style="text-align: center;">
                        <button class="btn btn-active" (click)="selectedSideFileRemove()">
                          <mat-icon>clear</mat-icon>Remove</button>
                      </div>
                      <div class="choose_file_side" *ngIf="sideImage == null">
                        <label for="choose_file_side">
                          <input type="file" id="choose_file_side" accept="image/png, image/gif, image/jpeg"
                            (change)="onFileSelected($event,3)">
                          <span>Click to Upload</span>
                        </label>

                      </div>

                    </div>

                  </mat-card-content>

                </mat-card>
              </div>

              <!-- Top Image -->
              <div class="image-upload-container">
                <mat-card appearance="outlined">
                  <mat-card-title class="flex justify-center content-stretch items-stretch">Top Image </mat-card-title>
                  <mat-card-content class="flex justify-center content-stretch items-stretch">
                    <div class="file-upload">
                      <div class="selected-file">
                        <img [src]="getBase64ImageSrc(topImage)??defaultImage" alt="drug image">
                      </div>
                      <div *ngIf="topImage!= null" style="text-align: center;">
                        <button class="btn btn-active" (click)="selectedTopFileRemove()">
                          <mat-icon>clear</mat-icon>Remove</button>
                      </div>
                      <div class="choose_file_top" *ngIf="topImage == null">
                        <label for="choose_file_top">
                          <input type="file" id="choose_file_top" accept="image/png, image/gif, image/jpeg"
                            (change)="onFileSelected($event,4)">
                          <span>Click to Upload</span>
                        </label>

                      </div>

                    </div>

                  </mat-card-content>

                </mat-card>
              </div>

              <!-- Package Image -->
              <div class="image-upload-container">
                <mat-card appearance="outlined">
                  <mat-card-title class="flex justify-center content-stretch items-stretch">Package Image </mat-card-title>
                  <mat-card-content class="flex justify-center content-stretch items-stretch">
                    <div class="file-upload">
                      <div class="selected-file">
                        <img [src]="getBase64ImageSrc(packageImage)??defaultImage" alt="drug image">
                      </div>
                      <div *ngIf="packageImage!= null" style="text-align: center;">
                        <button class="btn btn-active" (click)="selectedPackageFileRemove()">
                          <mat-icon>clear</mat-icon>Remove</button>
                      </div>
                      <div class="choose_file_package" *ngIf="packageImage == null">
                        <label for="choose_file_package">
                          <input type="file" id="choose_file_package" accept="image/png, image/gif, image/jpeg"
                            (change)="onFileSelected($event,5)">
                          <span>Click to Upload</span>
                        </label>

                      </div>

                    </div>

                  </mat-card-content>

                </mat-card>
              </div>

            </div>
          </div>

          <!-- Right column: Basic Info -->
          <div class="basic-info">
            <h4>Basic Information</h4>

            <!-- Country -->
            <div class="form-field" style="margin-bottom: .8rem;">
              <div class="flex flex-row">
                <span class="text-red-500">*</span>
                <span class="label">Country</span>
              </div>
              <mat-form-field class="no-line">
                <mat-select formControlName="country" ngDefaultControl>
                  <mat-option *ngFor="let data of countryList" [value]="data.value">{{data?.label}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="basicInfoForm.controls.country.hasError('required') && basicInfoForm.controls.country.touched">
                <mat-error *ngIf="basicInfoForm.controls.country.hasError('required')">Country is required</mat-error>
              </div>
            </div>

            <!-- Drug Type (Generic/Brand) -->
            <div class="form-field" style="margin-bottom: .8rem;">
              <div class="flex flex-row">
                <span class="text-red-500">*</span>
                <span class="label">Drug Type</span>
              </div>
              <mat-radio-group formControlName="genericNameIndicator">
                <mat-radio-button value="1">Generic</mat-radio-button>
                <mat-radio-button value="2">Brand</mat-radio-button>
              </mat-radio-group>
              <div
                *ngIf="basicInfoForm.controls.genericNameIndicator.hasError('required') && basicInfoForm.controls.genericNameIndicator.touched">
                <mat-error *ngIf="basicInfoForm.controls.genericNameIndicator.hasError('required')">Generic Name
                  Indicator is required</mat-error>
              </div>
            </div>

            <!-- OTC -->
            <div class="form-field" style="margin-bottom: .8rem;">
              <div class="flex flex-row">
                <span class="text-red-500">*</span>
                <span class="label">OTC</span>
              </div>
              <mat-form-field appearance="none" class="no-border">
                <mat-select formControlName="otcId">
                  <mat-option value="7">Yes</mat-option>
                  <mat-option value="8">No</mat-option>
                </mat-select>
                <div *ngIf="basicInfoForm.controls.otcId.hasError('required') && basicInfoForm.controls.otcId.touched">
                  <mat-error *ngIf="basicInfoForm.controls.otcId.hasError('required')">OTC is required</mat-error>
                </div>
              </mat-form-field>
            </div>

          </div>
        </div>
      </form>

      <div class="button-row">
        <button mat-button class="btn-blue-default btn-md" type="button" (click)="cancel()">Cancel</button>
        <button mat-button [ngClass]="{
          'btn-primary': basicInfoForm.valid,
          'btn-disabled': !basicInfoForm.valid
      }" color="primary" type="button" matStepperNext [disabled]="!basicInfoForm.valid">Next</button>

      </div>
    </mat-step>

    <!-- Step 2: Bottle Information -->
    <mat-step [stepControl]="bottleInfoForm" label="Bottle Information" state="local_drink">
      <ng-template matStepLabel>Bottle Information</ng-template>
      <form [formGroup]="bottleInfoForm" class="step-form">
        <!-- Image Preview -->
        <div class="image-gallery">
          <div class="image-card" *ngIf="frontImage">
            <div class="image-label">Front Image</div>
            <img [src]="'data:image/jpeg;base64,' + frontImage" alt="Front View" />
          </div>
          <div class="image-card" *ngIf="backImage">
            <div class="image-label">Back Image</div>
            <img [src]="'data:image/jpeg;base64,' + backImage" alt="Back View" />
          </div>
          <div class="image-card" *ngIf="sideImage">
            <div class="image-label">Side Image</div>
            <img [src]="'data:image/jpeg;base64,' + sideImage" alt="Side View" />
          </div>
          <div class="image-card" *ngIf="topImage">
            <div class="image-label">Top Image</div>
            <img [src]="'data:image/jpeg;base64,' + topImage" alt="Top View" />
          </div>
          <div class="image-card" *ngIf="packageImage">
            <div class="image-label">Package Image</div>
            <img [src]="'data:image/jpeg;base64,' + packageImage" alt="Package View" />
          </div>
        </div>

        <h3>Classification fields</h3>

        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Drug Number Type -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Drug Number Type</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="drugClassificationType" [(ngModel)]="data"
                (selectionChange)="updateDrugNumberFormat()">
                <mat-option *ngFor="let data of listOfDrugClassificationType"
                  [value]="data.value">{{data?.label}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="bottleInfoForm.controls.drugClassificationType.hasError('required') && bottleInfoForm.controls.drugClassificationType.touched">
              <mat-error *ngIf="bottleInfoForm.controls.drugClassificationType.hasError('required')">Drug Number type is
                required</mat-error>
            </div>
          </div>

          <!-- Drug Number Format -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Drug Number Format</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="drugNumberFormat">
                <mat-option *ngFor="let data of filteredDrugNumberFormat"
                  [value]="data.value">{{data?.label}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="bottleInfoForm.controls.drugNumberFormat.hasError('required') && bottleInfoForm.controls.drugNumberFormat.touched">
              <mat-error *ngIf="bottleInfoForm.controls.drugNumberFormat.hasError('required')">Drug Number Format is
                required</mat-error>
            </div>
          </div>


          <!-- Drug Number / Drug Id -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Drug Number</span>
            </div>
            <input formControlName="drugId" type="text">

            <div *ngIf="bottleInfoForm.controls.drugId.touched">
              <mat-error *ngIf="bottleInfoForm.controls.drugId.hasError('required')">Drug Number is required</mat-error>
              <mat-error *ngIf="bottleInfoForm.get('drugId')?.hasError('minlength')">Drug Number must be of {{
                bottleInfoForm.get('drugId')?.errors?.minlength?.requiredLength }} digits.</mat-error>
              <mat-error *ngIf="bottleInfoForm.get('drugId')?.hasError('maxlength')">Drug Number must be of {{
                bottleInfoForm.get('drugId')?.errors?.maxlength?.requiredLength }} digits.</mat-error>
              <mat-error *ngIf="bottleInfoForm.controls.drugId.hasError('drugIdExists')">Drug Number Already
                Exists</mat-error>
            </div>
          </div>


          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Drug Name</span>
            </div>

            <!-- Drug Name (list Drug Name data) Autocomplete Field -->
            <mat-form-field class="mat-form-field-autocomplete">
            <input matInput [formControl]="drugName" [matAutocomplete]="autoDrugName" id="drugNameInput">
              <mat-autocomplete #autoDrugName="matAutocomplete" [displayWith]="displayFnDrugName.bind(this)">
                <mat-option *ngFor="let drug of filteredDrugNames" [value]="drug">
                  {{ drug.label }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <div *ngIf="bottleInfoForm.get('drugName')?.hasError('required') && bottleInfoForm.get('drugName')?.touched">
                <mat-error>Drug Name is required</mat-error>
            </div>
          </div>

          <!-- Strength -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Strength</span>
            </div>
            <input formControlName="strength" type="text">

            <div *ngIf="bottleInfoForm.controls.strength.touched">
              <mat-error *ngIf="bottleInfoForm.controls.strength.errors?.required">
                Strength is required
              </mat-error>

              <mat-error *ngIf="bottleInfoForm.controls.strength.errors?.positiveRealNumber">
                {{ bottleInfoForm.controls.strength.errors?.positiveRealNumber }}
              </mat-error>
            </div>
          </div>
        </div>

        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- STR Unit -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">STR Unit</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="unit" ngDefaultControl>
                <mat-option *ngFor="let data of listofUnit" [value]="data.value">{{data?.label}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="bottleInfoForm.controls.unit.touched">
              <mat-error *ngIf="bottleInfoForm.controls.unit.hasError('required')">Unit is required</mat-error>
              <mat-error
                *ngIf="!bottleInfoForm.controls.unit.errors?.required && bottleInfoForm.controls.unit.hasError('invalidUnit')">Invalid
                Unit selected. Please select from the list.</mat-error>
            </div>
          </div>

          <!-- Manufacture -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Manufacturer</span>
            </div>
            <mat-form-field class="mat-form-field-autocomplete">
              <input type="text" aria-label="Number" matInput [formControl]="manufacturer"
                [matAutocomplete]="autoManufacturer">
              <mat-autocomplete #autoManufacturer="matAutocomplete" [displayWith]="displayFnManufacturer.bind(this)">
                <mat-option *ngFor="let data of listofManufacture" [value]="data.value">
                  {{data.label}}
                </mat-option>
                <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="25"></mat-spinner>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div *ngIf="manufacturer.touched">
              <mat-error *ngIf="manufacturer.hasError('required')">
                Manufacturer is required
              </mat-error>
              <mat-error *ngIf="manufacturer.hasError('invalidManufacturer')">
                Please select a valid manufacturer from the list
              </mat-error>
            </div>
          </div>

          <!-- Barcode -->
          <div class="flex flex-col  basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">12 Digit Barcode (UPC)</span>
            </div>
            <input formControlName="barcode" type="text">
            <div *ngIf="bottleInfoForm.controls.barcode.touched">
              <mat-error *ngIf="bottleInfoForm.controls.barcode.hasError('required')">Barcode
                is required</mat-error>
              <mat-error *ngIf="bottleInfoForm.controls.barcode.hasError('minlength')">Barcode must be at least 10
                digits</mat-error>
              <mat-error *ngIf="bottleInfoForm.controls.barcode.hasError('maxlength')">Barcode cannot exceed 12
                digits</mat-error>
              <mat-error *ngIf="bottleInfoForm.controls.barcode.hasError('pattern')">Barcode must be between 10-12
                digits</mat-error>
            </div>
          </div>

        </div>

        <h3>Product Attributes fields</h3>

        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Route of Administration -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Route Of Administration</span>
            </div>
            <mat-form-field class="mat-form-field-autocomplete">
              <input type="text" aria-label="Number" matInput [formControl]="routeOfAdministration"
                [matAutocomplete]="autoRoutOfAdministration">
              <mat-autocomplete #autoRoutOfAdministration="matAutocomplete"
                [displayWith]="displayFnRoutOfAddministration.bind(this)">
                <mat-option *ngFor="let data of filteredRouteOfAdministration" [value]="data.value">
                  {{data.label}}
                </mat-option>
                <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="25"></mat-spinner>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div *ngIf="bottleInfoForm.controls.routeOfAdministration.touched">
              <mat-error *ngIf="bottleInfoForm.controls.routeOfAdministration.hasError('required')">Route Of
                Administration is required</mat-error>
              <mat-error *ngIf="bottleInfoForm.controls.routeOfAdministration.hasError('invalidRouteOfAdmin')">Please
                enter a valid option</mat-error>
            </div>
          </div>

          <!-- Dosage Form Autocomplete -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="text-red-500">*</span>
              <span class="label">Dosage Form</span>
            </div>
            <mat-form-field class="mat-form-field-autocomplete">
              <input type="text" aria-label="Number" matInput [formControl]="dosageForm"
                [matAutocomplete]="autodosageForm">
              <mat-autocomplete #autodosageForm="matAutocomplete" [displayWith]="displayFnDosageForm.bind(this)">
                <mat-option *ngFor="let data of filteredDosageForm" [value]="data.id">
                  {{data.description}}
                </mat-option>
                <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="25"></mat-spinner>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div *ngIf="bottleInfoForm.controls.dosageForm.touched">
              <mat-error *ngIf="bottleInfoForm.controls.dosageForm.hasError('required')">Dosage Form is
                required</mat-error>
              <mat-error *ngIf="bottleInfoForm.controls.dosageForm.hasError('invalidDosageForm')">Please enter a valid
                option</mat-error>
            </div>
          </div>

          <!-- Niosh -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Niosh</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="niosh" ngDefaultControl>
                <mat-option *ngFor="let data of listOfNiosh" [value]="data.value">{{data?.value}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <!-- Schedule -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Schedule</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="schedule" ngDefaultControl>
                <mat-option *ngFor="let data of listOfSchedule" [value]="data.key">{{data?.value}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <!-- AntiBiotic -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">AntiBiotic</span>
            </div>
            <mat-form-field appearance="none">
              <mat-select formControlName="antibiotic" ngDefaultControl>
                <mat-option [value]="true">YES</mat-option>
                <mat-option [value]="false">NO</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>


        <h3>Packaging & Storage fields</h3>

        <div class="flex-row-package-storage-fields gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Storage Conditions -->
          <div class="flex flex-col basis-[20%]">
            <div class="flex flex-row">
              <span class="label">Storage Conditions</span>
            </div>
            <textarea formControlName="storageConditions" rows="7"></textarea>
          </div>

          <div class="flex flex-col basis-[80%]">

            <div class="flex-sub-row-1-package-storage-fields gap-[1rem]" style="margin-bottom: .8rem;">

              <!-- 2D Barcode -->
              <div class="flex flex-col basis-1/5">
                <div class="flex flex-row">
                  <span class="label">2D Barcode</span>
                </div>
                <input matInput type="text" formControlName="packageBarcode2d">
              </div>

              <!-- Package Type -->
              <div class="flex flex-col basis-1/5">
                <div class="flex flex-row">
                  <span class="label">Package Type </span>
                </div>
                <mat-form-field>
                  <mat-select formControlName="packageType" ngDefaultControl>
                    <mat-option *ngFor="let data of listOfPackageType" [value]="data.value">{{data.label}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Package Size -->
              <div class="flex flex-col basis-1/5">
                <div class="flex flex-row">
                  <span class="label">Package Qty</span>
                </div>
                <input type="text" aria-label="Number" matInput [formControl]="packageSize">
              </div>

              <!-- Unit of Use Dropdown -->
              <div class="flex flex-col basis-1/5">
                <div class="flex flex-row">
                  <span class="label">Unit of Use &nbsp;</span>
                  <span class="help_icon"
                    matTooltip=" The unit-of-use container as one that contains a specific quantity of a drug product that is intended to be dispensed as such without further modification except for the addition of appropriate labeling."
                    matTooltipPosition="after" matTooltipClass="custom_tooltip">
                    <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
                  </span>
                </div>
                <mat-form-field>
                  <mat-select formControlName="unitOfUse" ngDefaultControl>
                    <mat-option value="1">Yes</mat-option>
                    <mat-option value="0">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="flex-sub-row-2-package-storage-fields gap-[1rem]" style="margin-bottom: .8rem;">
              <!-- Unit of Use Dropdown -->
              <div class="flex flex-col basis-1/5">
                <div class="flex flex-row">
                  <span class="label">Unit Dose &nbsp;</span>
                  <span class="help_icon"
                    matTooltip=" The unit dose refers to a method of dispensing medications where each dose of a drug is individually packaged and labeled for a single administration to a patient."
                    matTooltipPosition="after" matTooltipClass="custom_tooltip">
                    <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
                  </span>
                </div>
                <mat-form-field>
                  <mat-select formControlName="unitDose" ngDefaultControl>
                    <mat-option value="1">Yes</mat-option>
                    <mat-option value="0">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

          </div>
        </div>

        <h4>Package Dimensions</h4>

        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Width -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Width (inches)</span>
            </div>
            <input type="number" matInput formControlName="packageWidth" />
          </div>

          <!-- Height -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Height (inches)</span>
            </div>
            <input type="number" matInput formControlName="packageHeight" />
          </div>

          <!-- Depth -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Depth (inches)</span>
            </div>
            <input type="number" matInput formControlName="packageDepth" />
          </div>

        </div>
      </form>

      <div class="button-row">
        <button mat-button type="button" matStepperPrevious>Back</button>
        <button mat-button class="btn-blue-default btn-md" type="button" (click)="cancel()">Cancel</button>
        <button mat-button [ngClass]="{
          'btn-primary': bottleInfoForm.valid,
          'btn-disabled': !bottleInfoForm.valid
      }" color="primary" type="button" matStepperNext [disabled]="!bottleInfoForm.valid">Next</button>
      </div>
    </mat-step>

    <!-- Step 3: Pill Information -->
    <mat-step [stepControl]="pillInfoForm" label="Pill Information" state="medication">
      <ng-template matStepLabel>Pill Information</ng-template>
      <form [formGroup]="pillInfoForm" class="step-form">
        <!-- Image Preview -->
        <div class="image-gallery">
          <div class="image-card" *ngIf="frontImage">
            <div class="image-label">Front Image</div>
            <img [src]="'data:image/jpeg;base64,' + frontImage" alt="Front View" />
          </div>
          <div class="image-card" *ngIf="backImage">
            <div class="image-label">Back Image</div>
            <img [src]="'data:image/jpeg;base64,' + backImage" alt="Back View" />
          </div>
          <div class="image-card" *ngIf="sideImage">
            <div class="image-label">Side Image</div>
            <img [src]="'data:image/jpeg;base64,' + sideImage" alt="Side View" />
          </div>
          <div class="image-card" *ngIf="topImage">
            <div class="image-label">Top Image</div>
            <img [src]="'data:image/jpeg;base64,' + topImage" alt="Top View" />
          </div>
          <div class="image-card" *ngIf="packageImage">
            <div class="image-label">Package Image</div>
            <img [src]="'data:image/jpeg;base64,' + packageImage" alt="Package View" />
          </div>
        </div>

        <h3>Pill Information</h3>

        <!-- Color -->
        <div class="flex flex-col basis-1/5">
          <div class="flex flex-row">
            <span class="text-red-500">*</span>
            <span class="label">Color (Select up to 2)</span>
          </div>

          <div class="color-chips">
            <button *ngFor="let color of allColorsWithBorderHexCodes" type="button" class="color-chip"
              [ngClass]="{'selected': isColorSelected(color)}" (click)="toggleColor(color.name)" [ngStyle]="{
                'border': color.name === 'CLEAR' ? isColorSelected(color.name) ? '2.4px solid #ccc' : '2.4px dashed #ccc' : '2.4px solid ' + color.hex,
                 'background': isColorSelected(color.name) ? color.name === 'CLEAR' ? 'whitesmoke' : color.hex : '#fff',
                 'color': isColorSelected(color.name)
                  ? (isLightColor(color.hex) ? '#222' : '#fff')
                  : '#222'
              }">
              {{color.name}}
            </button>
          </div>
          <div *ngIf="pillInfoForm.get('colors')?.hasError('required') && pillInfoForm.get('colors')?.touched"
            class="error-text">
            At least one color is required
          </div>

          <div *ngIf="pillInfoForm.controls.color.hasError('colorRequired') && pillInfoForm.controls.color.touched">
            <mat-error *ngIf="pillInfoForm.controls.color.hasError('colorRequired')">Color is required</mat-error>
          </div>

          <!-- Show "You can only select a maximum of 2 colors" error -->
          <div *ngIf="pillInfoForm.controls.color.hasError('maxColors') && pillInfoForm.controls.color.touched">
            <mat-error *ngIf="pillInfoForm.controls.color.hasError('maxColors')">You can only select a maximum of
              2 colors</mat-error>
          </div>
        </div>


        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Pill Shape -->
          <div class="flex flex-col basis-1/5" style="margin-top: 3px;">
            <div class="flex flex-row">
              <span class="label">Pill Shape</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="pillShape" ngDefaultControl>
                <mat-option *ngFor="let data of pillShapeList" [value]="data.value">{{data?.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Coating -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Coating</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="coating" ngDefaultControl>
                <mat-option *ngFor="let data of listOfCoating" [value]="data.key">{{data?.value}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Scoring -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Scoring</span>
            </div>
            <mat-form-field>
              <mat-select formControlName="scoring" ngDefaultControl>
                <mat-option *ngFor="let data of listOfScoaring" [value]="data.key">{{data?.value}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Imprint 1 -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Imprint 1</span>
            </div>
            <input formControlName="imprint1" type="text" />
          </div>

          <!-- Imprint 2 -->
          <div class="flex flex-col basis-1/5">
            <div class="flex flex-row">
              <span class="label">Imprint 2</span>
            </div>
            <input formControlName="imprint2" type="text" />
          </div>

        </div>
        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">
          <!-- Qty Classified -->
          <div class="flex flex-col basis-1/5">
            <span class="label">Qty Classified</span>
            <input formControlName="qtyClassified" type="text">
          </div>

          <!-- Qty Weighed -->
          <div class="flex flex-col basis-[10%]">
            <span class="label">Qty Weighted</span>
            <input formControlName="qtyWeighted" type="text">
          </div>

        </div>

        <h3>Dimensions</h3>
        <p>Entering the information below will trigger the calculation of device settings</p>
        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Length -->
          <div class="flex flex-col basis-[14%]">
            <span class="label">Length (inches)</span>
            <input appNumberValidator formControlName="length" type="number">
            <mat-error *ngIf="pillInfoForm.get('length')?.errors?.invalidPositiveNumber">
              Invalid input! Please enter a valid positive number.
            </mat-error>
          </div>

          <!-- Width -->
          <div class="flex flex-col basis-[14%]">
            <span class="label">Width (inches)</span>
            <input appNumberValidator formControlName="width" type="number">
            <mat-error *ngIf="pillInfoForm.get('width')?.errors?.invalidPositiveNumber">
              Invalid input! Please enter a valid positive number.
            </mat-error>
          </div>

          <!-- Thickness -->
          <div class="flex flex-col basis-[14%]">
            <span class="label">Thickness (inches)</span>
            <input appNumberValidator formControlName="thickness" type="number">
            <mat-error *ngIf="pillInfoForm.get('thickness')?.errors?.invalidPositiveNumber">
              Invalid input! Please enter a valid positive number.
            </mat-error>
          </div>

          <!-- Diagonal -->
          <div class="flex flex-col basis-[14%]">
            <span class="label">Diagonal (inches)</span>
            <input appNumberValidator formControlName="diagonal" type="number">
            <mat-error *ngIf="pillInfoForm.get('diagonal')?.errors?.invalidPositiveNumber">
              Invalid input! Please enter a valid positive number.
            </mat-error>
          </div>

          <!-- Piece Weight -->
          <div class="flex flex-col basis-[14%]">
            <span class="label">Piece Weight (grams)</span>
            <input appNumberValidator formControlName="pieceWeight" type="number">
            <mat-error *ngIf="pillInfoForm.get('pieceWeight')?.errors?.invalidPositiveNumber">
              Invalid input! Please enter a valid positive number.
            </mat-error>
          </div>
        </div>

        <div class="row flex gap-[1rem]" style="margin-bottom: .8rem;">

          <!-- Classification Shape -->
          <div class="flex flex-col basis-[14%]">
            <span class="label">Classification Shape</span>
            <mat-form-field>
              <mat-select formControlName="classificationShape" ngDefaultControl>
                <mat-option *ngFor="let data of listOfClassificationShape"
                  [value]="data.value">{{data?.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- 30 dram capacity -->
          <div class="flex flex-col basis-[14%]">
            <div class="flex flex-row">
              <span class="label">30 Dram Capacity</span>
            </div>
            <input appNumberValidator formControlName="thirtyDramCapacity" type="number" />
            <mat-error *ngIf="pillInfoForm.get('thirtyDramCapacity')?.errors?.invalidPositiveNumber">
              Invalid input! Please enter a valid positive number.
            </mat-error>
          </div>

        </div>
      </form>


      <div class="button-row">
        <button mat-button type="button" matStepperPrevious>Back</button>
        <button mat-button class="btn-blue-default btn-md" type="button" (click)="cancel()">Cancel</button>
        <button mat-button [ngClass]="{
          'btn-primary': pillInfoForm.valid,
          'btn-disabled': !pillInfoForm.valid
      }" color="primary" type="button" (click)="calculateAdscTcgMaxSynmedValues()" matStepperNext
          [disabled]="!pillInfoForm.valid">Next</button>

      </div>
    </mat-step>

    <!-- Step 4: ADSC Calculation (new step) -->
    <mat-step class="mat-step-adsc" *ngIf="showAdscStep()" [stepControl]="adscDeviceDataForm" label="ADSC Calculation"
      state="calculate">
      <!-- MAX Device Section -->
      <form [formGroup]="adscDeviceDataForm" class="step-form">

        <!-- Image Preview -->
        <div class="image-gallery">
          <div class="image-card" *ngIf="frontImage">
            <div class="image-label">Front Image</div>
            <img [src]="'data:image/jpeg;base64,' + frontImage" alt="Front View" />
          </div>
          <div class="image-card" *ngIf="backImage">
            <div class="image-label">Back Image</div>
            <img [src]="'data:image/jpeg;base64,' + backImage" alt="Back View" />
          </div>
          <div class="image-card" *ngIf="sideImage">
            <div class="image-label">Side Image</div>
            <img [src]="'data:image/jpeg;base64,' + sideImage" alt="Side View" />
          </div>
          <div class="image-card" *ngIf="topImage">
            <div class="image-label">Top Image</div>
            <img [src]="'data:image/jpeg;base64,' + topImage" alt="Top View" />
          </div>
          <div class="image-card" *ngIf="packageImage">
            <div class="image-label">Package Image</div>
            <img [src]="'data:image/jpeg;base64,' + packageImage" alt="Package View" />
          </div>
        </div>

        <div class="section-container">
          <div class="grid grid-cols-2 gap-10 section-heading">
            <div class="flex flex-col basis-[50%]">
              <h4 class="section-title">MAX Device Settings</h4>
            </div>
            <div class="flex flex-col basis-[15%] align-self-center justify-self-end">
              <mat-slide-toggle color="primary" [checked]="isMaxLabOptimized"
                (change)="OnMaxLabOptimizedToggle($event)">
                Lab Optimized
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div class="flex flex-col">
              <span class="label">Max Cell Height</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="maxCellHeight">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Max Cell Width</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="maxCellWidth">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Max Pressure</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="maxPressure">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Max Baffle</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="maxBaffle">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Cell Capacity</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="cellCapacity">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Super Cell Capacity</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="superCellCapacity">
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Synmed Device Section -->
        <div class="section-container">
          <div class="grid grid-cols-2 gap-10 section-heading">
            <div class="flex flex-col basis-[50%]">
              <h4 class="section-title">Synmed Device Settings</h4>
            </div>
            <div class="flex flex-col basis-[15%] align-self-center justify-self-end">
              <mat-slide-toggle color="primary" [checked]="isSynmedLabOptimized"
                (change)="OnSynmedLabOptimizedToggle($event)">
                Lab Optimized
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div class="flex flex-col">
              <span class="label">Preferred Lid Hole Size</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="preferredLidHoleSize">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Preferred Pipette Size</span>
              <mat-form-field>
                <mat-select formControlName="preferredPipetteSize" ngDefaultControl>
                  <mat-option *ngFor="let value of preferredPipetteSize" [value]="value">{{value}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Preferred Container Size</span>
              <mat-form-field>
                <mat-select formControlName="preferredContainerSize" ngDefaultControl>
                  <mat-option *ngFor="let value of preferredContainerSize" [value]="value">{{value}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Use Both Canisters</span>
              <mat-form-field appearance="none">
                <mat-select formControlName="useBothCanisters" ngDefaultControl>
                  <mat-option [value]="true">True</mat-option>
                  <mat-option [value]="false">False</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Lid Volcanic</span>
              <mat-form-field appearance="none">
                <mat-select formControlName="preferredLidVolcanic" ngDefaultControl>
                  <mat-option [value]="true">True</mat-option>
                  <mat-option [value]="false">False</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Mass Index</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="massIndex">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Mass Index Concat</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="massIndexConcat">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Pipette Drop Height</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="pipetteDropHeight">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Small Pipette Drop Height</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="smallPipetteDropHeight">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Large Pipette Drop Height</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="largePipetteDropHeight">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Small Canister Capacity</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="smallContainerCapacity">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">Large Canister Capacity</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="largeContainerCapacity">
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- TCG Device Section -->
        <div class="section-container">
          <div class="grid grid-cols-2 gap-10 section-heading">
            <div class="flex flex-col basis-[50%]">
              <h4 class="section-title">ATP Device Settings</h4>
            </div>
            <div class="flex flex-col basis-[15%] align-self-center justify-self-end">
              <mat-slide-toggle color="primary" [checked]="isATPLabOptimized"
                (change)="OnATPLabOptimizedToggle($event)">
                Lab Optimized
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div class="flex flex-col">
              <span class="label">Canister Capacity</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="canisterCapacity">
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <span class="label">High Cap Capacity</span>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="highCapCapacity">
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <div class="button-row">
        <button mat-button type="button" matStepperPrevious>Back</button>
        <button mat-button class="btn-blue-default btn-md" type="button" (click)="cancel()">Cancel</button>
        <button mat-button [ngClass]="{
        'btn-primary': adscDeviceDataForm.valid,
        'btn-disabled': !adscDeviceDataForm.valid
    }" color="primary" type="button" matStepperNext [disabled]="!adscDeviceDataForm.valid">Next</button>
      </div>
    </mat-step>

    <!-- Step 5: Final Review & Submit -->
    <mat-step label="Review & Submit" state="check_circle">
      <ng-template matStepLabel>Review & Submit</ng-template>
      <div class="step-form">
        <h4>Review & Submit</h4>

        <!-- Drug Images -->
        <div class="review-section">
          <div class="section-header">
            <h5>Drug Images</h5>
            <button mat-button class="btn-edit" (click)="editStep(0)">Edit</button>
          </div>
          <!-- Image Preview -->
          <div class="image-gallery">
            <div class="image-card" *ngIf="frontImage">
              <div class="image-label">Front Image</div>
              <img [src]="'data:image/jpeg;base64,' + frontImage" alt="Front View" />
            </div>
            <div class="image-card" *ngIf="backImage">
              <div class="image-label">Back Image</div>
              <img [src]="'data:image/jpeg;base64,' + backImage" alt="Back View" />
            </div>
            <div class="image-card" *ngIf="sideImage">
              <div class="image-label">Side Image</div>
              <img [src]="'data:image/jpeg;base64,' + sideImage" alt="Side View" />
            </div>
            <div class="image-card" *ngIf="topImage">
              <div class="image-label">Top Image</div>
              <img [src]="'data:image/jpeg;base64,' + topImage" alt="Top View" />
            </div>
            <div class="image-card" *ngIf="packageImage">
              <div class="image-label">Package Image</div>
              <img [src]="'data:image/jpeg;base64,' + packageImage" alt="Package View" />
            </div>
          </div>
        </div>

        <!-- Basic Information -->
        <div class="review-section">
          <div class="section-header">
            <h5>Basic Information</h5>
            <button mat-button class="btn-edit" (click)="editStep(0)">Edit</button>
          </div>
          <div class="review-grid">
            <div class="review-item">
              <span class="item-label">Country:</span>
              <span class="item-value">{{ getCountryLabel(basicInfoForm.get('country')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Generic Name Indicator:</span>
              <span class="item-value"> {{ basicInfoForm.get('genericNameIndicator')?.value === "1" ? 'Generic' :
                'Brand'}}</span>
            </div>
            <div class="review-item">
              <span class="item-label">OTC ID:</span>
              <span class="item-value">{{ basicInfoForm.get('otcId')?.value === "7" ? "OTC" : "Rx" }}</span>
            </div>
          </div>
        </div>

        <!-- Bottle Information -->
        <div class="review-section">
          <div class="section-header">
            <h5>Bottle Information</h5>
            <button mat-button class="btn-edit" (click)="editStep(1)">Edit</button>
          </div>

          <!-- Classification -->
          <div class="subsection">
            <h6 class="subsection-header">Classification</h6>
            <div class="review-grid">
              <div class="review-item">
                <span class="item-label">Drug Classification Type:</span>
                <span class="item-value">{{
                  displayFnBottleInfoDrugClassificationType(bottleInfoForm.get('drugClassificationType')?.value)
                  }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Drug Number Format:</span>
                <span class="item-value">{{
                  displayFnBottleInfoDrugNumberFormat(bottleInfoForm.get('drugNumberFormat')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Drug ID:</span>
                <span class="item-value">{{ bottleInfoForm.get('drugId')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Drug Name:</span>
                <span class="item-value">{{ bottleInfoForm.get('drugName')?.value?.label }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Strength:</span>
                <span class="item-value">{{ bottleInfoForm.get('strength')?.value &&
                  bottleInfoForm.get('strength')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Unit:</span>
                <span class="item-value">{{ bottleInfoForm.get('unit')?.value &&
                  displayFnUnit(bottleInfoForm.get('unit')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Manufacturer:</span>
                <span class="item-value">{{ bottleInfoForm.get('manufacturer')?.value &&
                  displayFnManufacturer(bottleInfoForm.get('manufacturer')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Barcode:</span>
                <span class="item-value">{{ bottleInfoForm.get('barcode')?.value && bottleInfoForm.get('barcode')?.value
                  }}</span>
              </div>
            </div>
          </div>

          <!-- Product Attributes -->
          <div class="subsection">
            <h6 class="subsection-header">Product Attributes</h6>
            <div class="review-grid">
              <div class="review-item">
                <span class="item-label">Route of Administration:</span>
                <span class="item-value">{{ bottleInfoForm.get('routeOfAdministration')?.value &&
                  displayFnRoutOfAddministration(bottleInfoForm.get('routeOfAdministration')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Dosage Form:</span>
                <span class="item-value">{{ bottleInfoForm.get('dosageForm')?.value &&
                  displayFnDosageForm(bottleInfoForm.get('dosageForm')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">NIOSH:</span>
                <span class="item-value">{{ bottleInfoForm.get('niosh')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Schedule:</span>
                <span class="item-value">{{ bottleInfoForm.get('schedule')?.value &&
                  displayFnBottleInfoSchedule(bottleInfoForm.get('schedule')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Antibiotic:</span>
                <span class="item-value">{{ bottleInfoForm.get('antibiotic')?.value === "true" ? "YES" :
                  bottleInfoForm.get('antibiotic')?.value === "false" ? "NO" : "" }}</span>
              </div>
            </div>
          </div>

          <!-- Packaging & Storage -->
          <div class="subsection">
            <h6 class="subsection-header">Packaging & Storage</h6>
            <div class="review-grid">
              <div class="review-item">
                <span class="item-label">Storage Conditions:</span>
                <span class="item-value">{{ bottleInfoForm.get('storageConditions')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Package Barcode 2D:</span>
                <span class="item-value">{{ bottleInfoForm.get('packageBarcode2d')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Package Type:</span>
                <span class="item-value">{{ bottleInfoForm.get('packageType')?.value &&
                  displayFnPacakgeType(bottleInfoForm.get('packageType')?.value) }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Package Size:</span>
                <span class="item-value">{{ bottleInfoForm.get('packageSize')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Unit of Use:</span>
                <span class="item-value">{{ bottleInfoForm.get('unitOfUse')?.value == 1 ? "Yes" : "No" }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Unit Dose:</span>
                <span class="item-value">{{ bottleInfoForm.get('unitDose')?.value == 1 ? "Yes" : "No"}}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Package Dimensions:</span>
                <span class="item-value">
                  W: {{ bottleInfoForm.get('packageWidth')?.value || '-' }} ×
                  H: {{ bottleInfoForm.get('packageHeight')?.value || '-' }} ×
                  D: {{ bottleInfoForm.get('packageDepth')?.value || '-' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Pill Information -->
        <div class="review-section">
          <div class="section-header">
            <h5>Pill Information</h5>
            <button mat-button class="btn-edit" (click)="editStep(2)">Edit</button>
          </div>
          <div class="review-grid">
            <div class="review-item">
              <span class="item-label">Color:</span>
              <span class="item-value">{{ pillInfoForm.get('color')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Pill Shape:</span>
              <span class="item-value">{{ pillInfoForm.get('pillShape')?.value &&
                displayFnPillInfoPillShape(pillInfoForm.get('pillShape')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Coating:</span>
              <span class="item-value">{{ pillInfoForm.get('coating')?.value &&
                displayFnPillInfoCoating(pillInfoForm.get('coating')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Scoring:</span>
              <span class="item-value">{{ pillInfoForm.get('scoring')?.value &&
                displayFnPillInfoScoring(pillInfoForm.get('scoring')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Imprints:</span>
              <span class="item-value">
                {{ pillInfoForm.get('imprint1')?.value }}
                {{ pillInfoForm.get('imprint2')?.value ? ' / ' + pillInfoForm.get('imprint2')?.value : '' }}
              </span>
            </div>
            <div class="review-item">
              <span class="item-label">Dimensions:</span>
              <span class="item-value">
                L: {{ pillInfoForm.get('length')?.value || '-' }} ×
                W: {{ pillInfoForm.get('width')?.value || '-' }} ×
                T: {{ pillInfoForm.get('thickness')?.value || '-' }}
              </span>
            </div>
            <div class="review-item">
              <span class="item-label">Diagonal:</span>
              <span class="item-value">{{ pillInfoForm.get('diagonal')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Piece Weight:</span>
              <span class="item-value">{{ pillInfoForm.get('pieceWeight')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Classification Shape:</span>
              <span class="item-value">{{
                displayFnPillInfoClassificationShape(pillInfoForm.get('classificationShape')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">30 Dram Capacity:</span>
              <span class="item-value">{{ pillInfoForm.get('thirtyDramCapacity')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Quantity Classified:</span>
              <span class="item-value">{{ pillInfoForm.get('qtyClassified')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="item-label">Quantity Weighted:</span>
              <span class="item-value">{{ pillInfoForm.get('qtyWeighted')?.value }}</span>
            </div>
          </div>
        </div>


        <!-- ADSC Calculation -->
        <div class="review-section" *ngIf="showAdscStep()">
          <div class="section-header">
            <h5>ADSC Calculation</h5>
            <button mat-button class="btn-edit" (click)="editStep(3)">Edit</button>
          </div>

          <!-- MAX Device Settings -->
          <div class="subsection">
            <h6 class="subsection-header">MAX Device Settings</h6>
            <div class="review-grid">
              <div class="review-item">
                <span class="item-label">Lab Optimized:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('maxLabOptimized')?.value === 'true' ? 'Yes' : 'No'
                  }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Max Cell Height:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('maxCellHeight')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Max Cell Width:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('maxCellWidth')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Max Pressure:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('maxPressure')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Max Baffle:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('maxBaffle')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Cell Capacity:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('cellCapacity')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Super Cell Capacity:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('superCellCapacity')?.value }}</span>
              </div>
            </div>
          </div>

          <!-- Synmed Device Settings -->
          <div class="subsection">
            <h6 class="subsection-header">Synmed Device Settings</h6>
            <div class="review-grid">
              <div class="review-item">
                <span class="item-label">Lab Optimized:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('synmedLabOptimized')?.value === 'true' ? 'Yes' :
                  'No' }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Preferred Lid Hole Size:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('preferredLidHoleSize')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Preferred Pipette Size:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('preferredPipetteSize')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Preferred Container Size:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('preferredContainerSize')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Use Both Canisters:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('useBothCanisters')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Lid Volcanic:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('lidVolcanic')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Mass Index:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('massIndex')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Mass Index Concat:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('massIndexConcat')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Pipette Drop Height:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('pipetteDropHeight')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Small Pipette Drop Height:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('smallPipetteDropHeight')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Large Pipette Drop Height:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('largePipetteDropHeight')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Small Canister Capacity:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('smallCanisterCapacity')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Large Canister Capacity:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('largeCanisterCapacity')?.value }}</span>
              </div>
            </div>
          </div>

          <!-- TCG Device Settings -->
          <div class="subsection">
            <h6 class="subsection-header">TCG Device Settings</h6>
            <div class="review-grid">
              <div class="review-item">
                <span class="item-label">Lab Optimized:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('atpLabOptimized')?.value === 'true' ? 'Yes' : 'No'
                  }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">Canister Capacity:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('canisterCapacity')?.value }}</span>
              </div>
              <div class="review-item">
                <span class="item-label">High Cap Capacity:</span>
                <span class="item-value">{{ adscDeviceDataForm.get('highCapCapacity')?.value }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="button-row">
        <button mat-button class="btn-blue-default btn-md" (click)="cancel()" id="CancelNewUser" aria-label="Cancel"
          type="button">Cancel</button>
        <button mat-button aria-label="Save Drug" [ngClass]="{
      'btn-primary': isFormValid(),
      'btn-disabled': !isFormValid()
    }" [disabled]="!isFormValid()" id="Next" (click)="save()" class="btn-md" type="button">
          Save Drug
        </button>
      </div>

    </mat-step>

  </mat-horizontal-stepper>
</div>
